/* ---------------------------------------------------------------------
   One cart read at a time.

   Every cart script on the page reads GET /cart.js on its own: the three
   reconcilers and the reward rail below, the personalization fee sync, the
   drawer, the mega menu's cart count, the screen protector upsell, the
   leather set page, and app embeds. Each also reacts to every cart write
   and to every cart:refresh the others dispatch, so one page load and one
   Add to Cart came to 30-45 reads of the same cart within a few seconds.
   That is enough to trip the store's rate limit, and every read is a round
   trip a shopper's phone waits on.

   A read is only as fresh as the last write before it, so reads that start
   after the same write can share one answer. This keeps that one answer:

   - a GET /cart.js made while another is in flight gets a copy of that
     one's response instead of a second request;
   - for a short moment after it lands, the same response answers new reads
     too;
   - only while no cart write has started since it was requested. Any
     POST to /cart/add, change, update or clear (fetch or XHR) makes the
     next read go to the network, and no read is shared while a write is
     in flight. So a read that follows a write always sees that write.

   Everything else passes straight through: other URLs, reads with a query
   string, an AbortSignal or a Request object, and every failed read (an
   error or a non-200 is never reused). Each caller gets its own clone, so
   each can read the body once, as it would have with its own request.
   window.__gcCartReads counts network reads and shared ones.
   --------------------------------------------------------------------- */
(function () {
  if (typeof window.fetch !== 'function' || window.__gcCartReads) return;
  var base = window.fetch;
  var WRITE = /\/cart\/(add|change|update|clear)(\.js)?$/;
  var READ = /^(\/[a-z]{2,3}(-[a-z0-9]{2,4})?)?\/cart\.js$/i;
  var KEEP = 800;                       /* ms a landed response stays shareable */
  var gen = 0, writing = 0, entry = null;
  var stats = window.__gcCartReads = { network: 0, shared: 0 };

  function parse(u) {
    try {
      var s = typeof u === 'string' ? u : (u && u.url) || String(u);
      return new URL(s, location.href);
    } catch (e) { return null; }
  }
  function wrote() { gen++; entry = null; }

  window.fetch = function (u, init) {
    var isReq = typeof Request !== 'undefined' && u instanceof Request;
    var url = parse(u);
    if (!url || url.origin !== location.origin) return base.apply(this, arguments);
    var method = String((init && init.method) || (isReq && u.method) || 'GET').toUpperCase();

    if (method !== 'GET' && method !== 'HEAD' && WRITE.test(url.pathname)) {
      wrote(); writing++;
      var w = base.apply(this, arguments);
      var settle = function () { writing = Math.max(0, writing - 1); wrote(); };
      w.then(settle, settle);
      return w;
    }

    if (method !== 'GET' || isReq || url.search || !READ.test(url.pathname) ||
        (init && (init.signal || init.body))) {
      return base.apply(this, arguments);
    }

    var e = entry;
    if (e && e.path === url.pathname && e.gen === gen && !writing &&
        (!e.at || Date.now() - e.at < KEEP)) {
      stats.shared++;
      return e.p.then(function (r) { return r.clone(); });
    }

    stats.network++;
    var mine = { path: url.pathname, gen: gen, at: 0, p: null };
    mine.p = base.apply(this, arguments).then(function (r) {
      if (r.ok) mine.at = Date.now();
      else if (entry === mine) entry = null;
      return r;
    }, function (err) {
      if (entry === mine) entry = null;
      throw err;
    });
    entry = writing ? null : mine;
    return mine.p.then(function (r) { return r.clone(); });
  };

  var xo = XMLHttpRequest.prototype.open, xs = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (m, u) {
    var url = parse(u);
    this.__gcWrite = !!(url && url.origin === location.origin &&
      String(m).toUpperCase() !== 'GET' && WRITE.test(url.pathname));
    return xo.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    if (this.__gcWrite) {
      wrote(); writing++;
      this.addEventListener('loadend', function () { writing = Math.max(0, writing - 1); wrote(); });
    }
    return xs.apply(this, arguments);
  };
})();

/* The product page renders its price as "$89" plus a raised, quieter ".00",
   built by custom.js when it composes the product meta. The cart never got
   that treatment because its prices come out of a Liquid money filter as one
   finished string, so the cents arrive already welded to the figure.

   Splitting has to happen after render, and it has to survive re-render: the
   drawer replaces its own contents on every quantity change, and the cart
   page reloads its section. An observer is the only thing that covers both
   without knowing which of them is painting.

   Currency-safe by construction. The separator is whatever sits in front of
   the final two digits — a period in "$89.00", a comma in "89,00 €" — and
   anything after it is left alone, so the euro sign stays outside the raised
   span. A format with no cents at all ("¥8900") simply never matches. */
(function () {
  var SEL = [
    '.CartItem__PriceList .Price:not(.Price--compareAt)',
    '.CartItem__LinePriceList .Price:not(.Price--compareAt)',
  ].join(',');

  /* the last separator followed by exactly two digits, with nothing but
     non-digits allowed to trail it */
  var CENTS = /([.,]\d{2})(?=\D*$)/;

  function split(el) {
    if (!el || el.querySelector('.decimal')) return;
    /* only touch a node whose entire content is the money string; if the
       theme has already put elements inside, leave it alone rather than
       clobber them */
    if (el.children.length) return;
    var txt = el.textContent;
    if (!txt) return;
    var m = txt.match(CENTS);
    if (!m) return;
    /* nothing to raise on a whole amount (17 Oct 2026): the cart prints "$89", so a ".00" that still
       arrives (an app, a cached fragment) is dropped rather than raised */
    if (/^[.,]00$/.test(m[1])) { el.textContent = txt.slice(0, m.index) + txt.slice(m.index + m[1].length); return; }
    var i = m.index;
    var head = txt.slice(0, i);
    var cents = m[1];
    var tail = txt.slice(i + cents.length);
    el.textContent = head;
    var span = document.createElement('span');
    span.className = 'decimal';
    span.textContent = cents;
    el.appendChild(span);
    if (tail) el.appendChild(document.createTextNode(tail));
  }

  function sweep(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var list = scope.querySelectorAll(SEL);
    for (var i = 0; i < list.length; i++) split(list[i]);
    /* the root itself may BE a price when a single node was replaced */
    if (root && root.matches && root.matches(SEL)) split(root);
  }

  var queued = false;
  function schedule(root) {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; sweep(root); });
  }

  function start() {
    sweep(document);
    if (!('MutationObserver' in window)) return;
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        if (records[i].addedNodes && records[i].addedNodes.length) { schedule(document); return; }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/* ---------------------------------------------------------------------
   The reward rail, updated in place.

   Two separate things repaint the drawer after an add: the theme fetches
   the cart section and swaps the whole .Cart element, and personalize-
   drawer.js writes into the same subtree again a few hundred milliseconds
   later. Each one re-inserts the rail, each re-insertion takes a fresh
   backdrop-filter snapshot, and the two together are what reads as the
   cart loading and then loading again.

   Nothing here can stop those repaints. What it can do is make the rail
   correct BEFORE the first one lands and keep it correct through both, so
   the bar slides to its new value on a transition instead of arriving
   twice at two different lengths. --gc-progress is a custom property, so
   moving it moves the fill without touching a single node.
   --------------------------------------------------------------------- */
(function () {
  var RAIL = '[data-gc-rewards]';
  var busy = false;

  function money(cents, fmt) {
    /* "$10 away", not "$10.00"; "$10.05" keeps its cents (owner, 17 Oct 2026) */
    var v = (cents / 100).toFixed(2).replace(/\.00$/, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return String(fmt || '${{amount}}').replace(/\{\{\s*amount[^}]*\}\}/, v);
  }

  /* the same arithmetic the Liquid does, in hundredths of a percent, so the
     two can never disagree about where a dot is */
  function progress(spent, c1, c2, c3) {
    var p;
    if (spent >= c3) p = 10000;
    else if (spent >= c2) p = Math.floor((spent - c2) * 3333 / (c3 - c2)) + 5000;
    else if (spent >= c1) p = Math.floor((spent - c1) * 3333 / (c2 - c1)) + 1667;
    else p = Math.floor(spent * 1667 / c1);
    return Math.min(10000, Math.max(0, p)) / 100;
  }

  function paint(el, total) {
    var c1 = +el.getAttribute('data-t1'), c2 = +el.getAttribute('data-t2'), c3 = +el.getAttribute('data-t3');
    if (!c1 || !c2 || !c3) return;
    el.style.setProperty('--gc-progress', progress(total, c1, c2, c3) + '%');

    var nodes = el.querySelectorAll('.gc-rewards__node');
    var caps = [c1, c2, c3];
    for (var i = 0; i < nodes.length && i < 3; i++) {
      nodes[i].classList.toggle('is-on', total >= caps[i]);
    }

    var togo = el.querySelector('[data-gc-rewards-togo]');
    if (!togo) return;
    var gap = total < c1 ? c1 - total : total < c2 ? c2 - total : total < c3 ? c3 - total : 0;
    var tpl = el.getAttribute('data-togo-tpl') || '';
    var all = el.getAttribute('data-all-tpl') || '';
    var fmt = el.getAttribute('data-money') || '';
    if (!tpl && !all) return;
    var html = gap > 0
      ? tpl.replace('__AMOUNT__', '<b>' + money(gap, fmt) + '</b>')
      : all;
    if (togo.innerHTML.trim() === html.trim()) return;
    /* fade the sentence rather than swapping it mid-slide */
    el.classList.add('is-updating');
    setTimeout(function () {
      togo.innerHTML = html;
      el.classList.remove('is-updating');
    }, 200);
  }

  function refresh() {
    var els = document.querySelectorAll(RAIL);
    if (!els.length || busy) return;
    busy = true;
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        /* the same basis the Liquid uses — see gc-cart-rewards.liquid */
        var spent = (c.original_total_price != null) ? c.original_total_price : c.total_price;
        document.querySelectorAll(RAIL).forEach(function (el) { paint(el, spent); });
      })
      .catch(function () {})
      .then(function () { busy = false; });
  }

  /* every rail goes live one frame after it appears, which cancels the entry
     sweep and hands the bar over to the transition */
  function live() {
    document.querySelectorAll(RAIL).forEach(function (el) {
      if (el.classList.contains('gc-rewards--live')) return;
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { el.classList.add('gc-rewards--live'); });
      });
    });
  }

  function start() {
    live();
    document.documentElement.addEventListener('cart:refresh', function () { live(); refresh(); });
    document.addEventListener('cart:refresh', function () { live(); refresh(); });

    /* the ordinary add/change path does not dispatch cart:refresh, so the
       write itself is the signal */
    var f = window.fetch;
    if (typeof f === 'function') {
      window.fetch = function (u) {
        var out = f.apply(this, arguments);
        if (typeof u === 'string' && /\/cart\/(add|change|update|clear)/.test(u)) {
          out.then(function () { setTimeout(refresh, 120); }).catch(function () {});
        }
        return out;
      };
    }
    var xo = XMLHttpRequest.prototype.open, xs = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (m, u) { this.__gcCart = /\/cart\/(add|change|update|clear)/.test(String(u)); return xo.apply(this, arguments); };
    XMLHttpRequest.prototype.send = function () {
      if (this.__gcCart) this.addEventListener('loadend', function () { setTimeout(refresh, 120); });
      return xs.apply(this, arguments);
    };

    /* a rail inserted by a section re-render has to be taken live too */
    if ('MutationObserver' in window) {
      new MutationObserver(function () { live(); }).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();

/* ---------------------------------------------------------------------
   The $300 reward, reconciled.

   One rule, applied after every cart change: at or above the threshold the
   keychain line exists, below it the line does not. Stated that way rather
   than as "add on crossing / remove on falling back", it is idempotent —
   a reload, a back button, a second tab, or a cart restored from a session
   all converge on the same answer instead of double-adding.

   The reward is a real $0 variant rather than a discounted line, so nothing
   here has to negotiate with the store's other automatic discounts. It also
   means the guard is self-correcting: someone who finds the unlisted URL and
   adds it by hand has it removed again on their next cart change.

   Threshold is read from the rail so the two can never disagree about what
   $300 means, and it is compared against original_total_price for the same
   reason the rail is.

   A shopper may say no. Remove on the keychain line writes the cart
   attribute _reward_keychain_declined=1 and drops the line in ONE
   /cart/update.js request, so there is never a moment where the line is
   gone but the rule does not yet know it was refused. While the attribute
   is set the rule never adds the line back; the drawer shows an "Add it
   back" control instead, which clears the attribute and restores the line,
   again in one request. The attribute lives on the cart, so the answer
   survives reloads and new pages for as long as that cart does. An emptied
   cart is a new start: the attribute is cleared when nothing is left in it.
   The underscore keeps it out of the order page and the checkout.
   --------------------------------------------------------------------- */
(function () {
  var REWARD = 50241917812993;   /* Leather Keychain, $0.00, unlisted */
  var FLAG = '_reward_keychain_declined';
  var busy = false, again = false, lastSig = '', tries = 0;

  function threshold() {
    var el = document.querySelector('[data-gc-rewards]');
    var t = el && +el.getAttribute('data-t2');
    return t || 30000;
  }

  function post(url, body) {
    return fetch(url, {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    });
  }

  function announce() {
    try {
      /* once, on <html>: it bubbles to document and window, so every
         listener hears it exactly once (a second dispatch on document made
         the document listeners run twice, each with its own cart read) */
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    } catch (e) {}
  }

  function isDeclined(c) {
    var v = c && c.attributes ? c.attributes[FLAG] : '';
    return v != null && String(v) !== '' && String(v) !== '0';
  }

  function reconcile() {
    if (busy) { again = true; return; }
    /* Undo is putting lines back (window.__gcCartHold, gc-cart-undo.js; Oct 2026): no write until it
       is done, so its add and this rule never cross on the cart. Looked at again shortly. */
    if (window.__gcCartHold && window.__gcCartHold()) { setTimeout(schedule, 300); return; }
    busy = true;
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var line = null;
        for (var i = 0; i < c.items.length; i++) {
          if (c.items[i].variant_id === REWARD || c.items[i].id === REWARD) { line = c.items[i]; break; }
        }
        var declined = isDeclined(c);
        /* what the rule is trying to change; unchanged means the last write
           did nothing, whatever status it came back with */
        var sig = c.item_count + '/' + c.original_total_price + '/' + (line ? line.quantity : 'x') + '/' + (declined ? 'd' : '');
        if (sig !== lastSig) { lastSig = sig; tries = 0; }
        /* Same basis as the rail, or the two would disagree about whether the
           keychain has been earned — and the shopper would see a lit dot with
           no keychain in the basket. The reward is $0, so it cannot inflate
           the figure it is measured against. */
        var spent = (c.original_total_price != null) ? c.original_total_price : c.total_price;
        var qualifies = spent >= threshold();
        var others = c.item_count - (line ? line.quantity : 0);

        var write = null;
        if (declined && others <= 0) {
          /* nothing left in the cart: the refusal belonged to that basket */
          write = function () { var a = {}; a[FLAG] = ''; return post('/cart/update.js', { attributes: a }); };
        } else if (qualifies && !line && !declined) {
          write = function () { return post('/cart/add.js', { items: [{ id: REWARD, quantity: 1 }] }); };
        } else if (!qualifies && line) {
          /* /cart/update.js rather than /cart/change.js: the drawer offers
             "Undo" after every change-to-zero, and undoing a rule is a loop */
          write = function () { var u = {}; u[line.key] = 0; return post('/cart/update.js', { updates: u }); };
        } else if (qualifies && line && line.quantity !== 1) {
          /* one is the only sensible quantity for a reward */
          write = function () { return post('/cart/change.js', { id: line.key, quantity: 1 }); };
        }
        if (!write) return null;
        if (window.__gcCartHold && window.__gcCartHold()) { again = true; return null; } /* Undo began meanwhile */
        /* three attempts against an unmoved cart is enough to conclude the
           store will not accept this line — stop asking rather than spend the
           rest of the session re-rendering the drawer over it */
        if (++tries > 3) return null;
        return write().then(announce);
      })
      .catch(function () {})
      .then(function () { busy = false; if (again) { again = false; schedule(); } });
  }

  /* Coalesce: a single add can trigger several signals, and each one would
     otherwise start its own /cart.js round trip. */
  var timer = null;
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(reconcile, 260);
  }

  /* Remove and "Add it back". Both are one request each, so the attribute
     and the line can never disagree, and both go through /cart/update.js,
     which the drawer does not answer with an Undo toast. */
  var pending = false;
  function decline(btn) {
    if (pending) return;
    pending = true;
    var key = btn.getAttribute('data-line-key');
    var body = { attributes: {}, updates: {} };
    body.attributes[FLAG] = '1';
    body.updates[key || REWARD] = 0;
    var row = btn.closest('.CartItemWrapper') || btn.closest('.CartItem');
    if (row) row.classList.add('is-gc-leaving');
    btn.setAttribute('aria-busy', 'true');
    post('/cart/update.js', body)
      .then(function (r) { if (!r.ok) throw new Error(r.status); announce(); })
      .catch(function () {
        if (row) row.classList.remove('is-gc-leaving');
        btn.removeAttribute('aria-busy');
      })
      .then(function () { pending = false; });
  }
  function restore(btn) {
    if (pending) return;
    pending = true;
    var body = { attributes: {}, updates: {} };
    body.attributes[FLAG] = '';
    body.updates[REWARD] = 1;
    btn.setAttribute('aria-busy', 'true');
    btn.disabled = true;
    post('/cart/update.js', body)
      .then(function (r) { if (!r.ok) throw new Error(r.status); announce(); })
      .catch(function () { btn.disabled = false; btn.removeAttribute('aria-busy'); })
      .then(function () { pending = false; });
  }

  function start() {
    schedule();
    document.documentElement.addEventListener('cart:refresh', schedule);
    document.addEventListener('cart:refresh', schedule);

    document.addEventListener('click', function (e) {
      var t = e.target && e.target.closest ? e.target : null;
      if (!t) return;
      var off = t.closest('[data-gc-reward-decline]');
      var on = off ? null : t.closest('[data-gc-reward-restore]');
      if (!off && !on) return;
      e.preventDefault();
      if (off) decline(off); else restore(on);
    });

    var f = window.fetch;
    if (typeof f === 'function') {
      window.fetch = function (u) {
        var out = f.apply(this, arguments);
        /* not /cart/add of the reward itself, or this recurses */
        if (typeof u === 'string' && /\/cart\/(add|change|update|clear)/.test(u)) {
          out.then(schedule).catch(function () {});
        }
        return out;
      };
    }
    var xo = XMLHttpRequest.prototype.open, xs = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (m, u) {
      this.__gcReward = /\/cart\/(add|change|update|clear)/.test(String(u));
      return xo.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function () {
      if (this.__gcReward) this.addEventListener('loadend', schedule);
      return xs.apply(this, arguments);
    };

    /* a cart restored on a back-navigation is a cart change too */
    window.addEventListener('pageshow', function (e) { if (e.persisted) schedule(); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();

/* ---------------------------------------------------------------------
   Gift packaging, per item.

   One rule, applied after every cart change: the gift line's quantity equals
   the number of giftable items in the basket (bags and backpacks are not
   giftable, 4 Oct 2026; see isBag) — four cases, four boxes — and
   with nothing to wrap the line does not exist at all.

   Stated as a fact about the end state rather than as "add one when a product
   is added", it is idempotent: a quantity stepper, a removal, a second tab, a
   back button and a restored session all converge on the same answer instead
   of drifting.

   Giftable means not an add-on and not a reward, read from the product type —
   the same field the cart line uses to decide whether it is a link and the
   same one the Bundle Eligible collection uses to stay out of the automatic
   discount. One definition of an add-on in the shop, in one place.
   --------------------------------------------------------------------- */
(function () {
  var GIFT = 50241832059137;      /* Gift Packaging, $15, unlisted */
  var SKIP = { 'add-on': 1, 'reward': 1 };
  var busy = false, again = false, lastSig = '', tries = 0;

  /* Bags and backpacks get no gift box (owner, 4 Oct 2026: "Remove Gift packaging $15.00 for Bags,
     backpacks - leave for the other products"). The rule is snippets/gcx-is-bag.liquid's
     window.GC_isBagType(type, title), used when the page prints it; otherwise the same rule here: a
     "Luggage Accessories" type is never a bag (the leather luggage tag keeps its gift box), a type with
     "Luggage & Bags" or "Motorcycle Bags" is one, and else a title with the whole word bag, bags,
     backpack or backpacks. Mirrored in gc-cart-price.js, gc-cart-undo.js, gcls-set.js and
     gcsb-builder.js; keep them in step with the snippet.
     So the gift line's quantity counts the other items only, and a basket of bags alone has no gift
     line (the zero rule below takes it out). */
  function isBag(it) {
    var ty = String((it && it.product_type) || ''), ti = String((it && (it.product_title || it.title)) || '');
    if (typeof window.GC_isBagType === 'function') return !!window.GC_isBagType(ty, ti);
    if (/Luggage Accessories/i.test(ty)) return false;
    if (/Luggage & Bags|Luggage &amp; Bags|Motorcycle Bags/i.test(ty)) return true;
    return /(^|[^A-Za-z\u00C0-\u024F])(bags?|backpacks?)(?![A-Za-z\u00C0-\u024F])/i.test(ti);
  }
  window.__gcIsBag = isBag;

  /* Published because the product page's tick needs the same answer before
     it decides whether to write to the cart or wait for Add to cart, and two
     copies of this rule would eventually disagree. */
  function units(c) {
    var n = 0;
    for (var i = 0; i < c.items.length; i++) {
      var it = c.items[i];
      if (it.variant_id === GIFT || it.id === GIFT) continue;
      if (SKIP[String(it.product_type || '').toLowerCase().replace(/^\s+|\s+$/g, '')]) continue;
      if (isBag(it)) continue;
      n += it.quantity;
    }
    return n;
  }
  function lineOf(c) {
    for (var i = 0; i < c.items.length; i++) {
      if (c.items[i].variant_id === GIFT || c.items[i].id === GIFT) return c.items[i];
    }
    return null;
  }
  window.__gcGiftUnits = units;
  window.__gcGiftLine = lineOf;
  window.__gcGiftVariant = GIFT;

  function post(url, body) {
    return fetch(url, {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    });
  }

  function announce() {
    try {
      /* once, on <html>: it bubbles to document and window, so every
         listener hears it exactly once (a second dispatch on document made
         the document listeners run twice, each with its own cart read) */
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    } catch (e) {}
  }

  /* A cart being read halfway through a two-request add — the product in
     flight, the box already landed — reads as "nothing to wrap", and acting
     on that would delete the box the shopper just asked for. So an empty
     reading is confirmed once before it is acted on. Every other correction
     is safe to make immediately. */
  var zeroSeen = false;

  function reconcile() {
    if (busy) { again = true; return; }
    /* Undo is putting lines back (window.__gcCartHold, gc-cart-undo.js; Oct 2026): no write until it
       is done, so its add and this rule never cross on the cart. Looked at again shortly. */
    if (window.__gcCartHold && window.__gcCartHold()) { setTimeout(schedule, 300); return; }
    busy = true;
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var line = lineOf(c);
        if (!line) { zeroSeen = false; lastSig = ''; tries = 0; return null; }
        var want = units(c);

        /* same guard as the reward: a quantity the store will not accept —
           stock, a per-order limit — would otherwise be requested again after
           every cart change, forever, each one re-rendering the drawer */
        var sig = c.item_count + '/' + line.quantity + '/' + want;
        if (sig !== lastSig) { lastSig = sig; tries = 0; }

        if (window.__gcCartHold && window.__gcCartHold()) { again = true; return null; } /* Undo began meanwhile */
        if (want === 0) {
          if (!zeroSeen) { zeroSeen = true; setTimeout(schedule, 900); return null; }
          zeroSeen = false;
          if (++tries > 3) return null;
          return post('/cart/change.js', { id: line.key, quantity: 0 }).then(announce);
        }
        zeroSeen = false;
        if (line.quantity === want) return null;
        if (++tries > 3) return null;
        return post('/cart/change.js', { id: line.key, quantity: want }).then(announce);
      })
      .catch(function () {})
      .then(function () { busy = false; if (again) { again = false; schedule(); } });
  }

  var timer = null;
  function schedule() {
    clearTimeout(timer);
    /* behind the keychain's 260ms: two writers on one cart are easier to
       reason about when they do not arrive together */
    timer = setTimeout(reconcile, 420);
  }
  window.__gcGiftSync = schedule;

  function start() {
    schedule();
    document.documentElement.addEventListener('cart:refresh', schedule);
    document.addEventListener('cart:refresh', schedule);

    var f = window.fetch;
    if (typeof f === 'function') {
      window.fetch = function (u) {
        var out = f.apply(this, arguments);
        if (typeof u === 'string' && /\/cart\/(add|change|update|clear)/.test(u)) {
          out.then(schedule).catch(function () {});
        }
        return out;
      };
    }
    var xo = XMLHttpRequest.prototype.open, xs = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (m, u) {
      this.__gcGift = /\/cart\/(add|change|update|clear)/.test(String(u));
      return xo.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function () {
      if (this.__gcGift) this.addEventListener('loadend', schedule);
      return xs.apply(this, arguments);
    };

    window.addEventListener('pageshow', function (e) { if (e.persisted) schedule(); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();

/* ---------------------------------------------------------------------
   Priority processing, once per order.

   The gift box wraps each item, so its quantity follows the basket. This
   moves the ORDER through the workshop — there is one queue position to buy
   however much is in the cart, so the rule is simply: exactly one, and none
   at all when there is nothing to process.

   Same convergence guard as the other two: a write that changes nothing is
   not re-sent forever.
   --------------------------------------------------------------------- */
(function () {
  var PRIORITY = 50247219740929;   /* Priority Processing, $10, unlisted */
  var SKIP = { 'add-on': 1, 'reward': 1 };
  var busy = false, again = false, lastSig = '', tries = 0;

  function post(url, body) {
    return fetch(url, {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    });
  }
  function announce() {
    try {
      /* once, on <html>: it bubbles to document and window, so every
         listener hears it exactly once (a second dispatch on document made
         the document listeners run twice, each with its own cart read) */
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    } catch (e) {}
  }
  /* anything that is not an add-on or a reward is something to process */
  function processable(c) {
    var n = 0;
    for (var i = 0; i < c.items.length; i++) {
      var it = c.items[i];
      if (SKIP[String(it.product_type || '').toLowerCase().replace(/^\s+|\s+$/g, '')]) continue;
      n += it.quantity;
    }
    return n;
  }

  var zeroSeen = false;

  function reconcile() {
    if (busy) { again = true; return; }
    /* Undo is putting lines back (window.__gcCartHold, gc-cart-undo.js; Oct 2026): no write until it
       is done, so its add and this rule never cross on the cart. Looked at again shortly. */
    if (window.__gcCartHold && window.__gcCartHold()) { setTimeout(schedule, 300); return; }
    busy = true;
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var line = null;
        for (var i = 0; i < c.items.length; i++) {
          if (c.items[i].variant_id === PRIORITY || c.items[i].id === PRIORITY) { line = c.items[i]; break; }
        }
        if (!line) { zeroSeen = false; lastSig = ''; tries = 0; return null; }
        var want = processable(c);

        var sig = c.item_count + '/' + line.quantity + '/' + want;
        if (sig !== lastSig) { lastSig = sig; tries = 0; }

        /* nothing to process — confirm once, the same way the gift line does,
           so a cart caught mid-add does not lose what was just asked for */
        if (window.__gcCartHold && window.__gcCartHold()) { again = true; return null; } /* Undo began meanwhile */
        if (want === 0) {
          if (!zeroSeen) { zeroSeen = true; setTimeout(schedule, 900); return null; }
          zeroSeen = false;
          if (++tries > 3) return null;
          return post('/cart/change.js', { id: line.key, quantity: 0 }).then(announce);
        }
        zeroSeen = false;
        /* one queue position, however many items are in it */
        if (line.quantity === 1) return null;
        if (++tries > 3) return null;
        return post('/cart/change.js', { id: line.key, quantity: 1 }).then(announce);
      })
      .catch(function () {})
      .then(function () { busy = false; if (again) { again = false; schedule(); } });
  }

  var timer = null;
  function schedule() {
    clearTimeout(timer);
    /* behind the other two, so three writers on one cart arrive in order */
    timer = setTimeout(reconcile, 560);
  }

  function start() {
    schedule();
    document.documentElement.addEventListener('cart:refresh', schedule);
    document.addEventListener('cart:refresh', schedule);
    var f = window.fetch;
    if (typeof f === 'function') {
      window.fetch = function (u) {
        var out = f.apply(this, arguments);
        if (typeof u === 'string' && /\/cart\/(add|change|update|clear)/.test(u)) {
          out.then(schedule).catch(function () {});
        }
        return out;
      };
    }
    var xo = XMLHttpRequest.prototype.open, xs = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (m, u) {
      this.__gcPriority = /\/cart\/(add|change|update|clear)/.test(String(u));
      return xo.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function () {
      if (this.__gcPriority) this.addEventListener('loadend', schedule);
      return xs.apply(this, arguments);
    };
    window.addEventListener('pageshow', function (e) { if (e.persisted) schedule(); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();

/* ---------------------------------------------------------------------
   "What's in the set", opened and closed.

   The disclosure under a Leather Set line (cart-items.liquid) and under a
   "Your Leather Set" group row (gc-cart-set-group.liquid, the set's pieces
   as separate lines tied by _set_id) is a button with aria-expanded and a
   list it controls. One delegated listener serves the drawer and /cart
   alike, and survives every re-render because it is on the document, not
   on the nodes the re-render replaces.

   The drawer repaints its whole list after each cart change (and the
   reconcilers above make changes of their own), so an open list would
   snap shut under the shopper. The open lists are remembered by key (the
   line key, or "set:<_set_id>" for a group, which outlives any one of its
   lines) and reopened, without the entry animation, when their node comes
   back.

   A piece's stepper or Remove inside a group re-renders the list the
   control lived in, which would drop keyboard focus to the page. The
   control is remembered (set, variant and which control) and focused again on
   the new node; when the piece itself is gone, focus goes to its group's
   toggle; when the group is gone too, nothing is forced. Only while focus
   is lost (on the body), and only for a few seconds after the click.
   --------------------------------------------------------------------- */
(function () {
  var open = {};
  var refocus = null;

  function keyOf(box) {
    return box.getAttribute('data-gc-set-key') || box.getAttribute('data-line-key');
  }

  function set(box, on, quiet) {
    var btn = box.querySelector('[data-gc-set-toggle]');
    var list = box.querySelector('.gc-set__list');
    if (!btn || !list) return;
    btn.setAttribute('aria-expanded', on ? 'true' : 'false');
    if (quiet) list.style.animation = 'none';
    list.hidden = !on;
  }

  function restore() {
    var boxes = document.querySelectorAll('[data-gc-set]');
    for (var i = 0; i < boxes.length; i++) {
      var k = keyOf(boxes[i]);
      var btn = boxes[i].querySelector('[data-gc-set-toggle]');
      if (k && open[k] && btn && btn.getAttribute('aria-expanded') !== 'true') set(boxes[i], true, true);
    }
    if (!refocus) return;
    var r = refocus;
    if (Date.now() > r.until) { refocus = null; return; }
    /* act only while focus is lost: the control that had it was replaced by
       a re-render. Focus the shopper moved elsewhere is left alone. */
    var a = document.activeElement;
    if (a && a !== document.body && a !== document.documentElement && document.contains(a)) {
      if (a !== r.el && !a.closest('.gc-lset')) refocus = null;
      return;
    }
    var target = null;
    var rows = document.querySelectorAll('[data-gc-set-key] .gc-lset__piece[data-gc-lset-piece]');
    for (var j = 0; j < rows.length && !target; j++) {
      var inSet = rows[j].closest('[data-gc-set-key]').getAttribute('data-gc-set-key') === r.set;
      if (inSet && rows[j].getAttribute('data-gc-lset-piece') === r.piece) {
        target = rows[j].querySelector('[data-gc-lset-step="' + r.step + '"]') ||
                 rows[j].querySelector('[data-gc-lset-step]');
      }
    }
    if (!target && r.set) {
      var groups = document.querySelectorAll('[data-gc-set-key]');
      for (var g = 0; g < groups.length && !target; g++) {
        if (groups[g].getAttribute('data-gc-set-key') === r.set) target = groups[g].querySelector('[data-gc-set-toggle]');
      }
    }
    /* never into a closed drawer or a collapsed list */
    if (!target || !target.getClientRects().length || target.closest('[aria-hidden="true"]')) return;
    r.el = target;
    try { target.focus({ preventScroll: true }); } catch (e) { target.focus(); }
  }

  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target : null;
    if (!t) return;
    var step = t.closest('[data-gc-lset-step]');
    if (step) {
      var grp = step.closest('[data-gc-set-key]');
      var row = step.closest('[data-gc-lset-piece]');
      /* the cart reconcilers may re-render the drawer two or three times
         after one change, so focus is put back after each for a while */
      refocus = {
        el: step, until: Date.now() + 9000,
        /* by variant within the set: a line's key changes with its
           quantity and its discounts, so it cannot name the new node */
        piece: row ? row.getAttribute('data-gc-lset-piece') : '',
        step: step.getAttribute('data-gc-lset-step'),
        set: grp ? grp.getAttribute('data-gc-set-key') : ''
      };
      return;
    }
    var btn = t.closest('[data-gc-set-toggle]');
    if (!btn) return;
    var box = btn.closest('[data-gc-set]');
    if (!box) return;
    e.preventDefault();
    var on = btn.getAttribute('aria-expanded') !== 'true';
    set(box, on, false);
    var k = keyOf(box);
    if (k) { if (on) open[k] = 1; else delete open[k]; }
  }, true);

  var queued = false;
  function start() {
    if (!('MutationObserver' in window)) return;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; restore(); });
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();

/* ---------------------------------------------------------------------
   Remove the whole set, and remove everything, from the drawer.

   Both ask first, in place, and both are ONE cart write:

   - "Remove set" (gc-cart-set-group.liquid) reads the cart, then sets every
     line carrying that _set_id to 0, together with the engraving fee lines
     tied to its case (_personalization_link = the case's
     _personalization_id), in one /cart/update.js. The pieces are ordinary
     lines, so nothing else is special: the automatic discounts are
     recomputed by the store, and the reconcilers above see the write and
     settle the keychain, the gift box and priority processing on their own
     rules, exactly as they do after a piece's own Remove.
   - "Remove all items" (cart-items.liquid) is /cart/clear.js. An empty cart
     is a new start for the keychain refusal; the reconciler clears it.

   The question is a panel ([data-gc-ask-panel]) named by the trigger's
   data-gc-ask. Over the set row it covers the row, and the row under it is
   inert while it asks; at the end of the list it takes the link's place.
   Escape or Cancel puts focus back on the trigger. The drawer re-renders
   after every cart change, the reconcilers' included, so an open question
   is reopened on the new node until it is answered. After the write the
   result is announced in a polite live region outside the drawer (the
   drawer's own nodes are replaced), and focus, lost with the node that had
   it, goes to the first control left in the list or to the drawer's close
   button when the cart is empty. Every word is a locale key rendered into
   the markup.
   --------------------------------------------------------------------- */
(function () {
  var asking = null;    /* id of the open question */
  var busy = false;
  var land = 0;         /* until when focus is put back after a write */
  var sr = null;

  function say(text) {
    if (!text) return;
    if (!sr) {
      sr = document.createElement('div');
      sr.className = 'gc-sr';
      sr.setAttribute('role', 'status');
      sr.setAttribute('aria-live', 'polite');
      sr.setAttribute('aria-atomic', 'true');
      document.body.appendChild(sr);
    }
    sr.textContent = '';
    setTimeout(function () { sr.textContent = text; }, 120);
  }

  function post(url, body) {
    return fetch(url, {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body || {}),
    }).then(function (r) { if (!r.ok) throw new Error(r.status); return r; });
  }

  function announce() {
    try { document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); } catch (e) {}
  }

  function panelOf(id) { return id ? document.getElementById(id) : null; }
  function triggerOf(id) {
    var ts = document.querySelectorAll('[data-gc-ask]');
    for (var i = 0; i < ts.length; i++) if (ts[i].getAttribute('data-gc-ask') === id) return ts[i];
    return null;
  }
  function rowOf(panel) { return panel.closest('.gc-lset') || panel.closest('.gc-clear'); }

  function focus(el) {
    if (!el) return;
    try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); }
  }

  /* The box that scrolls the list (the drawer's .Drawer__Main). */
  function scrollerOf(el) {
    for (var p = el.parentElement; p && p !== document.body && p !== document.documentElement; p = p.parentElement) {
      var oy = getComputedStyle(p).overflowY;
      if ((oy === 'auto' || oy === 'scroll') && p.scrollHeight > p.clientHeight + 1) return p;
    }
    return null;
  }

  /* Over a tall row (the set's list open) the question would sit in the
     middle of the list, away from the "Remove set" the shopper tapped: it
     is lined up with that button instead. A short row keeps it centered. */
  function place(panel, trig) {
    panel.style.justifyContent = '';
    panel.style.paddingTop = '';
    if (!trig || !panel.classList.contains('gc-ask--over')) return;
    var first = panel.firstElementChild, last = panel.querySelector('.gc-ask__btns');
    if (!first || !last) return;
    var pr = panel.getBoundingClientRect();
    var ch = last.getBoundingClientRect().bottom - first.getBoundingClientRect().top;
    if (!pr.height || pr.height < ch * 2.2) return;
    var tr = trig.getBoundingClientRect();
    var top = tr.top + tr.height / 2 - pr.top - ch / 2;
    top = Math.max(12, Math.min(top, pr.height - ch - 12));
    panel.style.justifyContent = 'flex-start';
    panel.style.paddingTop = Math.round(top) + 'px';
  }

  /* Keyboard focus goes to Cancel without the browser's own scroll (that
     would move the whole drawer), so the question is brought into view
     here: at the end of the list the panel is taller than the link it
     replaces, and over a row it may start above or end below the visible
     part of the list. Only the list scrolls, by the least that shows the
     question and both buttons; anything drawn over the list's edges (the
     footer's round button) is stepped past as well. */
  function reveal(el) {
    if (!el) return;
    var sc = scrollerOf(el);
    if (!sc) return;
    var over = el.classList.contains('gc-ask--over');
    var a = over ? el.firstElementChild : el;
    var z = over ? el.querySelector('.gc-ask__btns') : el;
    if (!a || !z) return;
    var pad = 12;
    function nudge(top, bot, lo, hi) {
      var d = 0;
      if (bot > hi) d = bot - hi;
      if (top - d < lo) d = top - lo;   /* never past the question's first line */
      if (d) sc.scrollTop += d;
      return d;
    }
    var s = sc.getBoundingClientRect();
    nudge(a.getBoundingClientRect().top, z.getBoundingClientRect().bottom, s.top + pad, s.bottom - pad);
    /* a hit test on the question and each button, in the middle and just
       outside its four corners (inside the pill's rounding): what covers
       one of them is stepped past, with a little air */
    var probes = [a === el ? el.querySelector('.gc-ask__q') : a].concat([].slice.call(el.querySelectorAll('.gc-ask__btn')));
    var lo = s.top + pad, hi = s.bottom - pad;
    for (var i = 0; i < probes.length; i++) {
      if (!probes[i]) continue;
      var r = probes[i].getBoundingClientRect();
      if (!r.height) continue;
      var ix = Math.min(r.height, r.width) / 2;
      var pts = [[r.left + r.width / 2, r.top + r.height / 2],
                 [r.left + ix, r.top - 4], [r.right - ix, r.top - 4],
                 [r.left + ix, r.bottom + 4], [r.right - ix, r.bottom + 4]];
      for (var k = 0; k < pts.length; k++) {
        var hit = document.elementFromPoint(pts[k][0], pts[k][1]);
        if (!hit || el.contains(hit) || hit.contains(el)) continue;
        var h = hit.getBoundingClientRect();
        if (h.top > r.top) hi = Math.min(hi, h.top - pad / 2);
        else lo = Math.max(lo, h.bottom + pad / 2);
      }
    }
    if (lo !== s.top + pad || hi !== s.bottom - pad) {
      nudge(a.getBoundingClientRect().top, z.getBoundingClientRect().bottom, lo, hi);
    }
  }

  function show(id, move) {
    var panel = panelOf(id), trig = triggerOf(id);
    if (!panel) return;
    var row = rowOf(panel);
    panel.hidden = false;
    if (trig) trig.setAttribute('aria-expanded', 'true');
    if (row) {
      row.classList.add('is-gc-asking');
      /* over the set row, the row under the question is out of reach */
      if (panel.classList.contains('gc-ask--over')) {
        for (var i = 0; i < row.children.length; i++) {
          if (row.children[i] !== panel) row.children[i].setAttribute('inert', '');
        }
      }
    }
    /* lined up before the link gives way, while its place can be read */
    place(panel, trig);
    if (row && !panel.classList.contains('gc-ask--over') && trig) trig.hidden = true;
    reveal(panel);
    if (move) focus(panel.querySelector('[data-gc-ask-cancel]'));
  }

  function hide(id, back) {
    var panel = panelOf(id), trig = triggerOf(id);
    if (panel) {
      var row = rowOf(panel);
      panel.hidden = true;
      panel.style.justifyContent = '';
      panel.style.paddingTop = '';
      var err = panel.querySelector('[data-gc-ask-err]');
      if (err) err.textContent = '';
      if (row) {
        row.classList.remove('is-gc-asking', 'is-gc-leaving');
        var inert = row.querySelectorAll('[inert]');
        for (var i = 0; i < inert.length; i++) inert[i].removeAttribute('inert');
      }
    }
    if (trig) { trig.hidden = false; trig.setAttribute('aria-expanded', 'false'); }
    if (back && trig) { reveal(trig); focus(trig); }
  }

  function open(id) {
    if (busy) return;
    if (asking && asking !== id) hide(asking, false);
    asking = id;
    show(id, true);
  }
  function close(back) {
    if (!asking || busy) return;
    var id = asking;
    asking = null;
    hide(id, back);
  }

  /* the set's lines and the fee lines that belong to its case: the engraving fee, and (Oct 2026) the case's $25
     Minimalist logo line (its _logo_link is the case's _logo_id), so the pair leaves in this one write */
  function setUpdates(cart, sid) {
    var up = {}, links = {}, logos = {}, n = 0;
    cart.items.forEach(function (it) {
      var p = it.properties || {};
      if (String(p._set_id == null ? '' : p._set_id).trim() !== sid) return;
      up[it.key] = 0; n++;
      if (p._personalization_id) links[String(p._personalization_id)] = 1;
      if (p._logo_id) logos[String(p._logo_id)] = 1;
    });
    cart.items.forEach(function (it) {
      var p = it.properties || {};
      if (p._personalization_link && links[String(p._personalization_link)]) up[it.key] = 0;
      if (p._logo_link && logos[String(p._logo_link)]) up[it.key] = 0;
    });
    return n ? up : null;
  }

  function go(btn) {
    if (busy) return;
    var id = asking;
    var panel = btn.closest('[data-gc-ask-panel]');
    if (!panel) return;
    var row = rowOf(panel);
    var kind = btn.getAttribute('data-gc-ask-go');
    var btns = panel.querySelectorAll('button');
    var err = panel.querySelector('[data-gc-ask-err]');
    busy = true;
    for (var i = 0; i < btns.length; i++) btns[i].disabled = true;
    btn.setAttribute('aria-busy', 'true');
    if (err) err.textContent = '';
    if (row && kind === 'set') row.classList.add('is-gc-leaving');
    var list = kind === 'all' && document.querySelector('#sidebar-cart .Cart__ItemList');
    if (list) list.classList.add('is-gc-leaving');

    var write;
    if (kind === 'all') {
      write = post('/cart/clear.js');
    } else {
      var sid = String(btn.getAttribute('data-gc-set-id') || '').trim();
      write = fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          var up = setUpdates(c, sid);
          /* already gone (another tab): the re-render below is the answer */
          return up ? post('/cart/update.js', { updates: up }) : null;
        });
    }
    write.then(function () {
      busy = false;
      asking = null;
      land = Date.now() + 6000;
      say(btn.getAttribute('data-gc-done'));
      announce();
    }).catch(function () {
      busy = false;
      for (var j = 0; j < btns.length; j++) btns[j].disabled = false;
      btn.removeAttribute('aria-busy');
      if (row) row.classList.remove('is-gc-leaving');
      if (list) list.classList.remove('is-gc-leaving');
      if (err) err.textContent = btn.getAttribute('data-gc-err') || '';
      reveal(panel);
      focus(panel.querySelector('[data-gc-ask-cancel]'));
      if (id) asking = id;
    });
  }

  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target : null;
    if (!t) return;
    var trig = t.closest('[data-gc-ask]');
    if (trig) { e.preventDefault(); open(trig.getAttribute('data-gc-ask')); return; }
    var cancel = t.closest('[data-gc-ask-cancel]');
    if (cancel) { e.preventDefault(); close(true); return; }
    var yes = t.closest('[data-gc-ask-go]');
    if (yes) { e.preventDefault(); go(yes); }
  });

  /* The drawer closes on Escape too (theme.js, on keyup). An Escape inside
     the question answers the question only: its keyup is kept from the
     drawer. */
  var ateEsc = false;
  function isEsc(e) { return e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27; }
  document.addEventListener('keydown', function (e) {
    if (!asking || !isEsc(e)) return;
    var panel = panelOf(asking);
    if (!panel || !panel.contains(document.activeElement)) return;
    ateEsc = true;
    e.stopPropagation();
    e.preventDefault();
    close(true);
  }, true);
  document.addEventListener('keyup', function (e) {
    if (!ateEsc || !isEsc(e)) return;
    ateEsc = false;
    e.stopPropagation();
  }, true);

  function lost() {
    var a = document.activeElement;
    return !a || a === document.body || a === document.documentElement || !document.contains(a);
  }

  function settle() {
    /* a re-render replaced the open question: open it again */
    if (asking) {
      var panel = panelOf(asking);
      if (!panel) { asking = null; }
      else if (panel.hidden) { show(asking, lost()); }
    }
    if (!land) return;
    if (Date.now() > land) { land = 0; return; }
    if (!lost()) return;
    var drawer = document.getElementById('sidebar-cart');
    if (!drawer || drawer.getAttribute('aria-hidden') === 'true') return;
    var items = drawer.querySelector('[data-cart-items-container]');
    var cands = items ? items.querySelectorAll('a[href], button:not([disabled]), input:not([type="hidden"])') : [];
    var target = null;
    for (var i = 0; i < cands.length && !target; i++) {
      if (cands[i].getClientRects().length && !cands[i].closest('[hidden], [inert]') && cands[i].tabIndex >= 0) target = cands[i];
    }
    focus(target || drawer.querySelector('.Drawer__Close'));
  }

  var queued = false;
  function start() {
    if (!('MutationObserver' in window)) return;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; settle(); });
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
